import { render, staticRenderFns } from "./CommunicationView.vue?vue&type=template&id=5dc6abf4"
import script from "./CommunicationView.vue?vue&type=script&lang=js"
export * from "./CommunicationView.vue?vue&type=script&lang=js"
import style0 from "./CommunicationView.vue?vue&type=style&index=0&id=5dc6abf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports